import { DashboardShell } from "./DashboardShell";
import { MetricCard } from "./MetricCard";
import { ChartCard } from "./ChartCard";
import { ActivityPanel } from "./ActivityPanel";
import { educationPreview } from "@/data/dashboardPreview.data";
import { DashboardContent } from "./DashboardContent";

interface Props {
    accent: string;
}

export function EducationDashboard({
    accent,
}: Props) {
    const preview = educationPreview;

    return (
        <DashboardShell
            accent={accent}
            title="School ERP"
            subtitle="Academic, administrative and financial operations"
            sidebar={[
                "Dashboard",
                "Admissions",
                "Students",
                "Faculty",
                "Attendance",
                "Examinations",
                "Finance",
                "Reports",
            ]}
        >
            <DashboardContent

                accent={accent}

                preview={educationPreview}

                activityTitle="Academic Activity"

            />

            <div className="mt-6 grid gap-3 md:grid-cols-4">

                {
                    [
                        {
                            label: "Exam Pass",
                            value: "98%",
                            trend: "+2%"
                        },
                        {
                            label: "Assignments Submitted",
                            value: "96%",
                            trend: "+4%"
                        },
                        {
                            label: "Library Usage",
                            value: "81%",
                            trend: "+7%"
                        },
                        {
                            label: "Parent Satisfaction",
                            value: "95%",
                            trend: "+3%"
                        },
                    ].map((metric) => (

                        <MetricCard
                            key={metric.label}
                            accent={accent}
                            label={metric.label}
                            value={metric.value}
                            trend={metric.trend}
                        />

                    ))
                }

            </div>

            {/* <div className="grid gap-6"> */}

                {/* =====================================================
                   Academic Operations
                ====================================================== */}

                {/* <div className="grid gap-6 lg:grid-cols-3">

                    <div className="rounded-2xl border border-border bg-card p-5">

                        <h3 className="text-sm font-semibold">
                            Upcoming Examinations
                        </h3>

                        <div className="mt-5 space-y-4">

                            {[
                                {
                                    exam: "Mathematics",
                                    date: "12 Aug",
                                },
                                {
                                    exam: "Science",
                                    date: "14 Aug",
                                },
                                {
                                    exam: "English",
                                    date: "17 Aug",
                                },
                                {
                                    exam: "Computer Science",
                                    date: "19 Aug",
                                },
                            ].map((item) => (

                                <div
                                    key={item.exam}
                                    className="flex items-center justify-between rounded-xl border border-border px-4 py-3"
                                >

                                    <div>

                                        <p className="font-medium">
                                            {item.exam}
                                        </p>

                                        <p className="text-xs text-muted-foreground">
                                            Mid-Term Examination
                                        </p>

                                    </div>

                                    <span
                                        className="rounded-full px-3 py-1 text-xs font-semibold"
                                        style={{
                                            background: `${accent}15`,
                                            color: accent,
                                        }}
                                    >
                                        {item.date}
                                    </span>

                                </div>

                            ))}

                        </div>

                    </div>
                    <div className="rounded-2xl border border-border bg-card p-5">

                        <h3 className="text-sm font-semibold">
                            Parent Communication
                        </h3>

                        <div className="mt-5 space-y-4">

                            {[
                                "PTM reminders sent to 240 parents.",
                                "Annual function invitation published.",
                                "Transport schedule updated.",
                                "Fee due reminder generated.",
                            ].map((message) => (

                                <div
                                    key={message}
                                    className="rounded-xl border border-border p-4"
                                >

                                    <p className="text-sm leading-relaxed">
                                        {message}
                                    </p>

                                </div>

                            ))}

                        </div>

                    </div>

                </div> */}
                {/* =====================================================
                   Academic KPIs
                ====================================================== */}

            {/* </div> */}

        </DashboardShell>
    );
}

